import { render, staticRenderFns } from "./ClassSchedule.vue?vue&type=template&id=c9b8b554&scoped=true"
import script from "./ClassSchedule.vue?vue&type=script&lang=ts"
export * from "./ClassSchedule.vue?vue&type=script&lang=ts"
import style0 from "./ClassSchedule.vue?vue&type=style&index=0&id=c9b8b554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b8b554",
  null
  
)

export default component.exports